import OneSignalVue3 from '@onesignal/onesignal-vue3'
export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const options = {
    appId: config.public.isDev ? '17acfd27-7b9e-4fc2-9e66-55909a07611c' : '08a52beb-fb49-4b74-a65e-d478b6125ed3',
    setConsentRequired: true
  }
  nuxtApp.vueApp.use(OneSignalVue3, options)
})
